<template>
    <div class="flex w-full gap-5 h-full studbook-type-view justify-content-around overflow-hidden">
        <div class="section-table w-full">
            <div class="flex justify-content-between align-items-center flex-wrap">
                <h2 class="page-header">{{ $t('message.studbookType.header') }}</h2>
                <CustomButton :label="$t('message.studbookType.addNewButton')" @click="addNewBook"/>
            </div>
            <BookTypeTable v-if="loaded" ref="bookTypeTable" v-model="selectedBook" @showForm="showForm"
                           :countries="countries" :horseBreed="horseBreed"/>
        </div>
        <LibyanOrnament/>
        <div id="scrollToForm" class="section-details">
            <div class="flex justify-content-between align-items-center pr-1">
                <h2 class="page-header">{{ createMode ? $t('message.studbookType.headerNew') : $t('message.studbookType.headerEdit') }}</h2>
                <CustomIconButton icon="pi pi-times" onlyIcon @click="hideForm" class="close-form-button" />
            </div>
            <BookTypeForm v-if="loaded" :selectedBook="selectedBook" @change-element="reloadTable"
                          @createMode="(val) => createMode = val" @hideForm="hideForm"
                          :countries="countries" :horseBreed="horseBreed"/>
        </div>
    </div>
</template>

<script>
import BookTypeTable from "./components/BookTypeTable";
import BookTypeForm from "@/views/dict/booktype/components/BookTypeForm";
import CustomButton from "@/components/form/CustomButton.vue";
import { ScrollToUtils } from "@/utils/ScrollToUtils";
import LibyanOrnament from "@/components/LibyanOrnament.vue";
import CustomIconButton from "@/components/form/CustomIconButton.vue";
import { ShowHideFormUtils } from "@/utils/ShowHideFormUtils";
import { getCountries } from "@/swagger/vue-api-client";

export default {
    name: "BookTypeListView",
    components: {
        LibyanOrnament,
        BookTypeTable,
        BookTypeForm,
        CustomButton,
        CustomIconButton,
    },
    data() {
        return {
            selectedBook: {},
            createMode: true,
            countries: [],
            horseBreed: localStorage.getItem("horseBreed"),
            loaded: false,
        }
    },
    beforeMount() {
        getCountries()
            .then((response) => {
                this.countries = response.data;
                this.loaded = true;
            });
    },
    mounted() {
        this.selectedBook = this.getClearBook();
    },
    methods: {
        getClearBook() {
            return {
                id: null,
                authority: "",
                code: "",
                // country: null,
            };
        },
        reloadTable() {
            this.$refs.bookTypeTable.reloadTable();
            this.selectedBook = this.getClearBook();
        },
        addNewBook() {
            ScrollToUtils.scrollToElement();
            this.$refs.bookTypeTable.addNewBook();
            this.selectedBook = this.getClearBook();
            this.showForm();
        },
        showForm() {
            ShowHideFormUtils.showHideVertical(".section-table", ".section-details");
        },
        hideForm() {
            ShowHideFormUtils.showHideVertical(".section-table", ".section-details", true);
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "../../../assets/theme/mytheme/variables";
    .studbook-type-view {
        @media screen and (max-width: 1200px) {
            flex-direction: column;
            align-items: center;
            .section-table, .section-details {
                width: 90% !important;
                overflow-y: unset;
                height: fit-content;
            }
            .close-form-button {
                display: none;
            }
        }
    }
    .section-table, .section-details {
        transition: 1s ease-in-out;
    }
    .section-details {
        width: 0;
        height: calc(100vh - 40px - $top-bar-height);;
        overflow-y: auto;
    }
</style>
